/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';

@Component({
  standalone: false,
  selector: 'adn-report-route-page',
  template: `
    <adn-report-list-page [readOnly]="readOnly">
    </adn-report-list-page>
  `
})
export class ReportRoutePageComponent {
  @Input() readOnly = false;
}
